const Yup = require('yup');
const R = require('ramda');

const accountObject = {
	first_name: Yup.string()
		.min(2, 'Too Short!')
		.max(24, 'Too Long!')
		.required(' Required'),
	last_name: Yup.string()
		.min(2, 'Too Short!')
		.max(50, 'Too Long!')
		.required('Required'),
	title: Yup.number().when({
		is: v => v !== 4020,
		then: Yup.number()
			.min(0, 'Please select your title')
			.required('Required')
	}),
	title_name: Yup.string()
		.when('title', {
			is: R.equals(4020),
			then: Yup.string().min(5).required('Required')
		})
		.nullable(),
	token: Yup.string().required('Required'),
	email: Yup.string().email('Invalid email').required('Required'),
	password: Yup.string()
		.min(8, 'Too Short!')
		.max(128, 'Too Long!')
		.matches(
			/^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[^\w\d\s:])([^\s]){8,16}$/,
			'Password must have 8 chars long, 1 capital letter, 1 digit and 1 special character'
		)
		.required('Required'),
	phone: Yup.string()
		.matches(/^\(\d{3}\)\d{3}-\d{4}$/, 'Phone must have 10 digits!')
		.required('Required')
};

const orgObject = {
	full_name: Yup.string()
		.min(2, 'Too Short!')
		.max(128, 'Too Long!')
		.required(' Required'),
	address_1: Yup.string()
		.min(2, 'Too Short!')
		.max(50, 'Too Long!')
		.required('Required'),
	address_2: Yup.string(),
	city: Yup.string()
		.min(2, 'Too Short!')
		.max(50, 'Too Long!')
		.required('Required'),
	state_id: Yup.number().required(),
	zip: Yup.string().length(5, 'Wrong length').required('Required'),
	phone: Yup.string()
		.transform(v => {
			console.log('Here it is', v);
			return v;
		})
		.matches(/^\(\d{3}\)\d{3}-\d{4}$/, 'Phone must have 10 digits!')
		.required('Required'),
	fax: Yup.string().matches(/^\(\d{3}\)\d{3}-\d{4}$/, {
		message: 'Fax must have 10 digits!',
		excludeEmptyString: true
	})
};

const clientPhoneObject = {
	phone: Yup.string()
		.matches(/^\(\d{3}\)\d{3}-\d{4}$/, 'Phone must have 10 digits!')
		.required('Required')
};

const invoicePayObject = {
	amount: Yup.number().required('Required'),
	type: Yup.number().required('Required'),
	paymentDate: Yup.date().required('Required')
};

module.exports = {
	accountObject,
	invoicePayObject,
	clientPhoneObject,
	orgObject
};
